import { Injectable } from "@angular/core";
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertaService {
  
  private showingError = false;

  public correct(_message: string, onClose?: () => void): void {
    Swal.fire({
      title: 'Correcto',
      text: _message,
      icon: 'success',
      allowOutsideClick: false
    }).then(() => onClose?.());
  }

  public error(message: string, options?: {
    detail?: string,                   // Texto adicional opcional
    onAccept?: () => void,             // Acción al dar "Aceptar"
  }) {
    if (this.showingError) return;
      this.showingError = true;
    //console.log('detail:', options?.detail);
    const hasDetail = options?.detail != null && options.detail.trim() !== '';
    //console.log('hasDetail:', hasDetail);

    Swal.fire({
      title: 'Error',
      text: message,
      icon: 'error',
      showCancelButton: hasDetail,  // Solo si hay detalle, muestra botón "Ver detalle"
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Ver detalle',
      //allowOutsideClick: false
    }).then(result => {
      if (result.isConfirmed) {
        if (options?.onAccept) {
          options.onAccept();
        }/*else{
          window.location.reload();
        }*/
      } else if (result.dismiss === Swal.DismissReason.cancel && options?.detail) {
        Swal.fire({
          title: 'Detalle del error',
          text: options.detail,
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: 'Aceptar'
        }).then(detailResult => {
          if (detailResult.isConfirmed) {
            options?.onAccept?.(); // Aquí también se llama
          }
        });
      }
    }).finally(() => {
      this.showingError = false;
    });
  }

  public information(_message: string){
    Swal.fire({
      title: "Informacion",
      text: _message,
      icon: "info",
      allowOutsideClick: false
    }); 
  }

  public question(title: string, message: string, textBtn: string, options?: {
    //detail?: string,                   // Texto adicional opcional
    onAccept?: () => void,             // Acción al dar "Aceptar"
    }
  ){
    Swal.fire({
      title: title, //"Are you sure?",
      text: message, //"You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: textBtn, //"Yes, delete it!",
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        /*Swal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success"
        });*/
        if (options?.onAccept) {
          options.onAccept();
        }
      }
    });
  }

}